<template>
  <div class="TitleLocation"
    :class="classes">

    <component class="TitleLocation-title"
      :is="titleWrapComponent"
      :to="titleRoute">

      <page-title :title="title" />

    </component>

    <p class="TitleLocation-location t-caps-md"
      v-if="location">
      <span class="TitleLocation-locationArrow">&rsaquo;</span>
      {{ location }}
    </p>

  </div>
</template>

<script>
export default {
  name: 'TitleLocation',

  props: {
    title: {
      type: String
    },
    titleRoute: {
      type: [String, Object]
    },
    location: {
      type: String
    },
    /**
     * Whether to display title and location inline
     */
    inline: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * Classes for the main element
     * @return {Array}
     */
    classes () {
      const classes = []

      if (this.inline) {
        classes.push('TitleLocation--inline')
      }

      return classes
    },

    /**
     * Element type for the title wrapping element
     * @return {String}
     */
    titleWrapComponent () {
      return this.titleRoute ? 'router-link' : 'div'
    }
  }
}
</script>

<style>
@import 'properties';

.TitleLocation {

  @media (min-width: 960px) {
    display: flex;
    align-items: baseline;
  }
}

.TitleLocation--inline {
  display: flex;
  align-items: baseline;
}

.TitleLocation-title {
  color: inherit;
}

.TitleLocation-location {
  margin-top: 14px;
  line-height: 1;

  @media (min-width: 960px) {
    margin-top: 0;
    margin-left: 8px;
  }
}

.TitleLocation--inline .TitleLocation-location {
  margin-top: 0;
  margin-left: 8px;
}

.TitleLocation-locationArrow {
  display: none;

  @media (min-width: 960px) {
    display: inline;
  }
}

.TitleLocation-locationArrow {
  margin-right: 6px;
  margin-left: 2px;
}

.TitleLocation--inline .TitleLocation-locationArrow {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// TitleLocation.vue?0e5a9062